export default {
    data () {
        return {
            oauth: {
                loading: 0,
                uid: 0,
                status: 0,
                accessToken: '',
            }
        }
    },
    filters: {
        percentageOfNumber (partialValue, totalValue) {
          return (totalValue) ? ( (totalValue / 100) * partialValue ).toFixed(2) : 0.00;
        },
        percentage (partialValue, totalValue) {
            return (totalValue) ? ( (100 * partialValue) / totalValue).toFixed(3) : 0.00;
        },
        nK(num, digits) {

            if (!num){
                return 0
            }

            var si = [
                {value: 1, symbol: ""},
                {value: 1E3, symbol: "k"},
                {value: 1E6, symbol: "M"},
                {value: 1E9, symbol: "B"},
                {value: 1E12, symbol: "T"},
                {value: 1E15, symbol: "P"},
                {value: 1E18, symbol: "E"}
            ];
            var rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
            var i;
            for (i = si.length - 1; i > 0; i--) {
                if (num >= si[i].value) {
                    break;
                }
            }
            return (num / si[i].value).toFixed(digits).replace(rx, "$1") + si[i].symbol;
        },
        numb(n, x) {
            return Number(n.toFixed(1)).toLocaleString()
        }
    },
    methods: {
        getCountNformatter (type) {
            var f = this.findByKey(this.stats, 'key', type)

            if (!f)
                return 0

            return this.nFormatter(f.total_count);
        },
        getCount (type) {
            var f = this.findByKey(this.stats, 'key', type)

            if (!f)
                return 0

            return f.total_count;
        },
        getAmountAvgChange (type) {
            var f = this.findByKey(this.stats, 'key', type)

            if (!f)
                return 0

            return f.total_avg_last_15m

        },
        getAmountChange (type) {
            var f = this.findByKey(this.stats, 'key', type)

            if (!f)
                return 0

            return f.total_amount_last_15m

        },
        getAmountAvgLast (type) {
            var f = this.findByKey(this.stats, 'key', type)

            if (!f)
                return 0

            return f.total_avg_last_15m

        },
        getAmountAvg (type) {
            var f = this.findByKey(this.stats, 'key', type)

            if (!f)
                return 0

            return f.total_avg

        },
        getAmountLast (type) {
            var f = this.findByKey(this.stats, 'key', type)

            if (!f)
                return 0

            return f.total_amount_last_15m

        },
        getAmount (type) {
            var f = this.findByKey(this.stats, 'key', type)

            if (!f)
                return 0

            return f.total_amount

        },
        getAmountMoneyAvg (type, format = 0) {
            var f = this.findByKey(this.stats, 'key', type)

            if (!f)
                return 0

            if (format == 0) {
                if (this.currency.position == 'before') {
                    return this.currency.symbol+''+this.nFormatter(f.total_avg, 3);
                }else {
                    return this.nFormatter(f.total_avg)+''+this.currency.symbol;
                }
            } else {

                return this.$options.filters.toMoney(f.total_avg, this.currency)
            }
        },
        getEarningsMoney (type, format = 0) {
            var f = this.findByKey(this.stats, 'key', type)

            if (!f)
                return 0

            if (format == 0) {
                if (this.currency.position == 'before') {
                    return this.currency.symbol+''+this.nFormatter(f.total_earnings, 3);
                }else {
                    return this.nFormatter(f.total_earnings)+''+this.currency.symbol;
                }
            } else {

                return this.$options.filters.toMoney(f.total_earnings, this.currency)
            }
        },
        getAmountMoney (type, format = 0) {
            var f = this.findByKey(this.stats, 'key', type)

            if (!f)
                return 0

            if (format == 0) {
                if (this.currency.position == 'before') {
                    return this.currency.symbol+''+this.nFormatter(f.total_amount, 3);
                }else {
                    return this.nFormatter(f.total_amount)+''+this.currency.symbol;
                }
            } else {

                return this.$options.filters.toMoney(f.total_amount, this.currency)
            }
        },
        getPercentageChange (oldNumber, newNumber){
            var oldNumber = (oldNumber) ? oldNumber : 0;
            var newNumber = (newNumber) ? newNumber : 0;

            if (oldNumber == 0 && newNumber == 0){
                return 0;
            }

            var decreaseValue = oldNumber - newNumber;

            var chance = (decreaseValue / oldNumber) * 100;

            return (chance > 0) ? -Math.abs(chance) : Math.abs(chance);
        },
        getPercentageChangeAmount(type){
            var oldNumber = this.getAmountLast(type)

            var decreaseValue = oldNumber - this.getAmount(type) ;

            var chance = (decreaseValue / oldNumber ) * 100;
            var change = (chance > 0) ? -Math.abs(chance) : Math.abs(chance);

            return this.nFormatter(change);
        },
        getPercentageChangeAmountAvg(type){
            var oldNumber = this.getAmountAvgLast(type)

            var decreaseValue = oldNumber - this.getAmountAvg(type) ;

            var chance = (decreaseValue / oldNumber ) * 100;
            var change = (chance > 0) ? -Math.abs(chance) : Math.abs(chance);

            return this.nFormatter(change);
        },
        getPercentageChangeNetProfit () {
            var f = this.netProfit;

            if (!f)
                return 0

            var oldNumber = f.total_amount - f.total_amount_last_15m;

            var decreaseValue = oldNumber - f.total_amount ;

            var chance = (decreaseValue / oldNumber ) * 100;
            var change = (chance > 0) ? -Math.abs(chance) : Math.abs(chance);

            return this.nFormatter(change);
        },
        getNetProfitMoney (format = 0) {
            var f = this.netProfit;

            if (!f)
                return 0

            if (format == 0) {
                if (this.currency.position == 'before') {
                    return this.currency.symbol+''+this.nFormatter(f.total_amount, 3);
                }else {
                    return this.nFormatter(f.total_amount)+''+this.currency.symbol;
                }
            }else {

                return this.$options.filters.toMoney(f.total_amount, this.currency)
            }

        },
        nFormatter (num, digits) {

            if (!num){
                return 0
            }

            var si = [
                {value: 1, symbol: ""},
                {value: 1E3, symbol: "k"},
                {value: 1E6, symbol: "M"},
                {value: 1E9, symbol: "B"},
                {value: 1E12, symbol: "T"},
                {value: 1E15, symbol: "P"},
                {value: 1E18, symbol: "E"}
            ];
            var rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
            var i;
            for (i = si.length - 1; i > 0; i--) {
                if (num >= si[i].value) {
                    break;
                }
            }
            return (num / si[i].value).toFixed(digits).replace(rx, "$1") + si[i].symbol;
        },

    }
}



// WEBPACK FOOTER //
// ./src/mixins/formatter.js